export const getAppsFunctions = type => {
    switch (type) {
        case 'eshop':
            return {
                Webareal: {
                    create_order: false,
                    set_tracking_number: true,
                    set_invoice: true,
                    set_public_order: true,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                WooCommerce: {
                    create_order: true,
                    set_tracking_number: true,
                    set_invoice: true,
                    set_public_order: true,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: true,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Shopify: {
                    create_order: true,
                    set_tracking_number: true,
                    set_invoice: true,
                    set_public_order: true,
                    set_paid: true,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                CsCart: {
                    create_order: false,
                    set_tracking_number: true,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                EshopRychlo: {
                    create_order: false,
                    set_tracking_number: false,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                BiznisWeb: {
                    create_order: false,
                    set_tracking_number: false,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Wix: {
                    create_order: false,
                    set_tracking_number: true,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: true,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Api: {
                    create_order: true,
                    set_tracking_number: true,
                    set_invoice: true,
                    set_public_order: true,
                    set_paid: true,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: true,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Ecwid: {
                    create_order: false,
                    set_tracking_number: true,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: true,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Prestashop: {
                    create_order: false,
                    set_tracking_number: true,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Magento: {
                    create_order: false,
                    set_tracking_number: true,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: true,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Upgates: {
                    create_order: true,
                    set_tracking_number: true,
                    set_invoice: true,
                    set_public_order: true,
                    set_paid: true,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                FastCentrik: {
                    create_order: false,
                    set_tracking_number: true,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Shoprenter: {
                    create_order: false,
                    set_tracking_number: false,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: true,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Blank: {
                    create_order: true,
                    set_tracking_number: true,
                    set_invoice: true,
                    set_public_order: true,
                    set_paid: true,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: true,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Eli: {
                    create_order: false,
                    set_tracking_number: false,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Unas: {
                    create_order: false,
                    set_tracking_number: true,
                    set_invoice: true,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: true,
                    ai_search: true,
                    ai_chatbot: true,
                },
                CreativeSites: {
                    create_order: false,
                    set_tracking_number: true,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Shoptet: {
                    create_order: false,
                    set_tracking_number: false,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Shoper: {
                    create_order: false,
                    set_tracking_number: true,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: true,
                    ai_search: true,
                    ai_chatbot: true,
                },
                MerchantPro: {
                    create_order: false,
                    set_tracking_number: true,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: true,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Gomag: {
                    create_order: true,
                    set_tracking_number: true,
                    set_invoice: true,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                IdoSell: {
                    create_order: false,
                    set_tracking_number: true,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: true,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                SkyShop: {
                    create_order: true,
                    set_tracking_number: true,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: true,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                Selly: {
                    create_order: false,
                    set_tracking_number: true,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: true,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: true,
                    ai_chatbot: true,
                },
                RedCart: {
                    create_order: false,
                    set_tracking_number: false,
                    set_invoice: false,
                    set_public_order: false,
                    set_paid: false,
                    ai_generate_products: true,
                    ai_generate_categories: true,
                    ai_related_products: false,
                    ai_search: false,
                    ai_chatbot: false,
                },
            };

        case 'accounting':
            return {
                SuperFaktura: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: true,
                    paid: true,
                    cancel: true,
                },
                Idoklad: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: true,
                    paid: true,
                    cancel: false,
                },
                Pohoda: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: true,
                    paid: true,
                    cancel: false,
                },
                Mrp: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: true,
                    paid: true,
                    cancel: false,
                },
                FakturyOnline: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: true,
                    paid: true,
                    cancel: false,
                },
                Fakturoid: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: false,
                    cancel: false,
                },
                Profit365: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: true,
                    cancel: false,
                },
                Billdu: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: true,
                    cancel: false,
                },
                Vyfakturuj: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: true,
                    paid: true,
                    cancel: false,
                },
                Onix: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: true,
                    cancel: false,
                },
                Abra: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: true,
                    cancel: false,
                },
                EshopRychlo: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: false,
                    cancel: false,
                },
                PohodaServer: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: true,
                    paid: false,
                    cancel: true,
                },
                Webareal: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: false,
                    cancel: false,
                },
                Inteo: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: false,
                    cancel: false,
                },
                KrosFakturacia: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: true,
                    cancel: false,
                },
                Szamlazz: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: true,
                    cancel: false,
                },
                Billingo: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: true,
                    paid: true,
                    cancel: false,
                },
                SmartBill: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: true,
                    cancel: false,
                },
                Oblio: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: true,
                    paid: false,
                    cancel: false,
                },
                Fakturownia: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: true,
                    cancel: false,
                },
                Ifirma: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: true,
                    cancel: false,
                },
                Infakt: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: true,
                    cancel: false,
                },
                Wfirma: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: true,
                    cancel: false,
                },
                FreshBooks: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: true,
                    cancel: false,
                },
                Xero: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: true,
                    cancel: false,
                },
                Flowii: {
                    create_invoice: true,
                    send_invoice: true,
                    regular_from_proforma: false,
                    paid: true,
                    cancel: false,
                },
            };

        case 'courier':
            return {
                Gls: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                SlovenskaPosta: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                Zasielkovna: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                Kurier123: {
                    tracking_url: true,
                    pickup_points: false,
                    check_delivered: true,
                },
                Remax: {
                    tracking_url: true,
                    pickup_points: false,
                    check_delivered: true,
                },
                Dpd: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                Geis: {
                    tracking_url: true,
                    pickup_points: false,
                    check_delivered: false,
                },
                Toptrans: {
                    tracking_url: true,
                    pickup_points: false,
                    check_delivered: true,
                },
                Fhb: {
                    tracking_url: true,
                    pickup_points: false,
                    check_delivered: false,
                },
                Ppl: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                Dhl: {
                    tracking_url: true,
                    pickup_points: false,
                    check_delivered: true,
                },
                Sps: {
                    tracking_url: true,
                    pickup_points: false,
                    check_delivered: false,
                },
                ExpressOne: {
                    tracking_url: false,
                    pickup_points: false,
                    check_delivered: false,
                },
                PaletExpress: {
                    tracking_url: false,
                    pickup_points: false,
                    check_delivered: false,
                },
                Sds: {
                    tracking_url: true,
                    pickup_points: false,
                    check_delivered: true,
                },
                Depo: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                DpdCz: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                Mpl: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                Qdl: {
                    tracking_url: true,
                    pickup_points: false,
                    check_delivered: true,
                },
                Fedex: {
                    tracking_url: true,
                    pickup_points: false,
                    check_delivered: false,
                },
                Acs: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                BoxNow: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: false,
                },
                DpdHu: {
                    tracking_url: true,
                    pickup_points: false,
                    check_delivered: true,
                },
                DpdPl: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: false,
                },
                DpdRo: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                FanCourier: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                Foxpost: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                Inpost: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                PocztaPolska: {
                    tracking_url: true,
                    pickup_points: false,
                    check_delivered: true,
                },
                Sameday: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                Boxpi: {
                    tracking_url: true,
                    pickup_points: false,
                    check_delivered: true,
                },
                Cargus: {
                    tracking_url: true,
                    pickup_points: true,
                    check_delivered: true,
                },
                Poiint: {
                    tracking_url: true,
                    pickup_points: false,
                    check_delivered: false,
                },
            };

        case 'storage':
            return {
                Oberon: {
                    import_orders: true,
                    sync_products: true,
                },
                Ikelp: {
                    import_orders: true,
                    sync_products: true,
                },
                Idoklad: {
                    import_orders: false,
                    sync_products: true,
                },
                Pohoda: {
                    import_orders: true,
                    sync_products: true,
                },
                Onix: {
                    import_orders: true,
                    sync_products: true,
                },
                Abra: {
                    import_orders: false,
                    sync_products: true,
                },
                SuperFaktura: {
                    import_orders: false,
                    sync_products: true,
                },
                MoneyS3: {
                    import_orders: true,
                    sync_products: true,
                },
                PohodaServer: {
                    import_orders: true,
                    sync_products: true,
                },
                KrosFakturacia: {
                    import_orders: false,
                    sync_products: true,
                },
                MkSoft: {
                    import_orders: true,
                    sync_products: true,
                },
                Brani: {
                    import_orders: true,
                    sync_products: true,
                },
            };

        case 'marketplace':
            return {
                Heureka: {
                    import_orders: true,
                    update_stock: false,
                    create_products: false,
                    set_delivered: false,
                    set_invoice: false,
                    set_tracking_number: false,
                },
                Mall: {
                    import_orders: true,
                    update_stock: true,
                    create_products: false,
                    set_delivered: true,
                    set_invoice: false,
                    set_tracking_number: true,
                },
                Amazon: {
                    import_orders: true,
                    update_stock: true,
                    create_products: true,
                    set_delivered: false,
                    set_invoice: false,
                    set_tracking_number: true,
                },
                Ebay: {
                    import_orders: true,
                    update_stock: true,
                    create_products: true,
                    set_delivered: false,
                    set_invoice: false,
                    set_tracking_number: true,
                },
                Etsy: {
                    import_orders: true,
                    update_stock: true,
                    create_products: true,
                    set_delivered: false,
                    set_invoice: false,
                    set_tracking_number: true,
                },
                Alza: {
                    import_orders: true,
                    update_stock: true,
                    create_products: true,
                    set_delivered: false,
                    set_invoice: false,
                    set_tracking_number: true,
                },
                Kaufland: {
                    import_orders: true,
                    update_stock: true,
                    create_products: true,
                    set_delivered: false,
                    set_invoice: true,
                    set_tracking_number: true,
                },
                Allegro: {
                    import_orders: true,
                    update_stock: true,
                    create_products: true,
                    set_delivered: true,
                    set_invoice: true,
                    set_tracking_number: true,
                },
                Emag: {
                    import_orders: true,
                    update_stock: true,
                    create_products: true,
                    set_delivered: false,
                    set_invoice: true,
                    set_tracking_number: false,
                },
            };

        case 'bank':
            return {
                Stripe: {
                    payments: true,
                },
                Besteron: {
                    payments: true,
                },
                Gopay: {
                    payments: true,
                },
                Mollie: {
                    payments: true,
                },
                Webpay: {
                    payments: true,
                },
                Tatrabanka: {
                    payments: true,
                },
                Slsp: {
                    payments: true,
                },
                Moneta: {
                    payments: true,
                },
                Fio: {
                    payments: true,
                },
                Citfin: {
                    payments: true,
                },
                Csp: {
                    payments: true,
                },
                Vub: {
                    payments: true,
                },
                Paypal: {
                    payments: true,
                },
            };

        default:
            return {};
    }
}
